import apiService from '../infrastructure/api.service.js';

export const userService = {
    getAllUsers,
    getUserByType,
    logout,
    register,
    editUser
};

async function getAllUsers() {
    return apiService.get('/users');
}

async function getUserByType(type) {
    return apiService.get(`/users/?userType=${type}`);
}

async function register(user) {
    return apiService.post('/registration/agent', user);
}

async function editUser(user) {
    return apiService.post('/user/update', user);
}

function logout() {
    // Logout logic can be implemented here if needed
}

